<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Global Styles */
* {
  box-sizing: border-box;
  font-family: Sora, Helvetica, Arial, sans-serif;
}

body {
  margin: 0;
  padding: 0;
  font-family: Sora, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}

/* Primary Color */
.primary--text {
  color: rgb(0, 102, 204) !important;
}

.primary {
  background-color: rgb(0, 102, 204) !important;
  border-color: rgb(5, 150, 105) !important;
}

/* Secondary Color */
.secondary--text {
  color: #424242 !important;
}

.secondary {
  background-color: #424242 !important;
  border-color: #424242 !important;
}

/* Utility Classes */
.text-center {
  text-align: center;
}

.mt-2 {
  margin-top: 8px;
}

.mt-4 {
  margin-top: 16px;
}

.mb-4 {
  margin-bottom: 16px;
}

.ml-1 {
  margin-left: 4px;
}

.pa-4 {
  padding: 16px;
}

.pa-6 {
  padding: 24px;
}

.ma-4 {
  margin: 16px;
}

/* Table Styles */
.v-table {
  font-size: 14px;
}

.v-table thead th {
  background-color: rgba(0, 102, 204, 0.1);
  font-weight: 600;
  color: rgb(0, 102, 204);
}
/* =========================================================
   ✅ VUETIFY 3 TABLE SCROLL OWNER
   ========================================================= */
.custom-data-table .v-table__wrapper {
  overflow-x: auto;
  overflow-y: auto;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.35) transparent;
}

/* =========================================================
   THIN TABLE SCROLLBAR
   ========================================================= */

/* Chrome / Edge / Safari */
.custom-data-table .v-table__wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.custom-data-table .v-table__wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.custom-data-table .v-table__wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.custom-data-table .v-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

</style>
